<template>
  <div>
    <h1>Editar Cliente</h1>
    <b-card no-body>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import Form from "../Components/Form.vue";
import { useRoute, useRouter } from "vue-router/dist/composables.js";
import { useActions } from "vuex-composition-helpers";
import { useNotify } from "@/composables/useNotify.js";

export default defineComponent({
  components: { Form },
  setup() {
    const $route = useRoute();
    const $router = useRouter();
    const $notifications = useNotify();

    const $actions = useActions("clientes", ["ActionNewCliente", "ActionShow"]);

    async function loadData(id) {
      try {
        await $actions.ActionShow(id);
      } catch (error) {
        $notifications.addNotification({
          message: error?.data?.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });

        $router.push({ name: "clientes_list" });
      }
    }

    onMounted(async () => {
      $actions.ActionNewCliente();
      await loadData($route.params.id);
    });

    return {
      loadData,
    };
  },
});
</script>

<style></style>
